import React from 'react';
import { PRODUCT_NAME } from './constants';
const modules = [{
  num: '1',
  title: 'Gymnastics Foundations™',
  tagline: 'Build Strong Foundations Before Progressing Skills',
  description: 'Visual coaching guides for body shapes, handstand alignment, landings, balance, mobility, apparatus readiness, foundation circuits and athlete assessments.',
  closing: 'See what to teach, what to correct, and when athletes are ready to progress.'
}, {
  num: '2',
  title: 'Skill Progression Library™',
  tagline: 'See Exactly What Comes Next',
  description: 'Step-by-step visual pathways from prerequisite → drill → development → skill across floor, beam, bars and vault.',
  closing: 'Clear progressions. Coaching cues. Common errors. Readiness checkpoints.'
}, {
  num: '3',
  title: 'Practice Builder System™',
  tagline: 'Build Better Practices in Minutes',
  description: 'Turn your training goal into an organized session using visual frameworks for warm-ups, skill blocks, stations, rotations, conditioning and mixed-level groups.',
  closing: 'No more starting with a blank page.'
}, {
  num: '4',
  title: 'Ready-to-Use Practice Plans™',
  tagline: 'Open. Adapt. Coach.',
  description: 'Complete practices with warm-ups, drills, skill work, stations, timing, conditioning and coaching cues already structured for you.',
  closing: 'Use them as-is or adapt them to your athletes.'
}, {
  num: '5',
  title: 'Season Planning System™',
  tagline: "Plan Beyond Today's Practice",
  description: 'Organize weekly training, skill priorities, development goals, training cycles and competition preparation in one visual roadmap.',
  closing: 'Know where your athletes are—and where they’re going next.'
}, {
  num: '6',
  title: 'Coaching Toolkit™',
  tagline: 'Everything You Need to Stay Organized',
  description: 'Ready-to-use athlete assessments, skill checklists, progress trackers, practice planners, attendance sheets and coaching tools.',
  closing: 'Less paperwork. Less searching. More coaching.'
}];
export function SystemSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-189" data-mp="1z79x0iix5z1o">
      <div className="max-w-4xl mx-auto" data-id="element-190" data-mp="1z5yroe9tsj8g">
        <div className="text-center mb-6" data-id="element-191" data-mp="1ua09j8f3bxgh">
          <p className="text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-1" data-id="element-192" data-mp="1u74cdmb2hct3">
            The Solution You've Been Looking For
          </p>
          <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-brand-ink mb-1 uppercase leading-tight" data-id="element-193" data-mp="1l7h9ew2ovyxx">
            One Complete 6-in-1 Visual Gymnastics Coaching System
          </h2>
          <p className="text-base font-bold text-brand-navy mb-3" data-id="element-194" data-mp="1bbe9lwvb8ce5">
            Everything organized. Everything visual. Ready to use.
          </p>
          <p className="text-base text-brand-slate font-medium max-w-3xl mx-auto leading-snug" data-id="element-195" data-mp="3al49yqmfwqd6">
            🤸 <span className="font-bold text-brand-ink" data-id="element-196" data-mp="35mkm2koad4i6">{PRODUCT_NAME}</span>{' '}
            brings your practice planning, skill development and everyday
            coaching resources together in one practical system.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-197" data-mp="3myr6jyzgfpvt">
          {modules.map(m => <a href="#pricing" key={m.num} className="bg-brand-cloud border border-brand-line p-4 rounded-xl flex gap-3 items-start shadow-sm hover:border-brand-blue hover:shadow-md transition-all cursor-pointer group" data-id="element-198" data-mp="3rxcaa8dx0rp0">
              <div className="bg-brand-navy text-white font-display font-bold w-9 h-9 flex items-center justify-center rounded-lg shrink-0 group-hover:bg-brand-blue transition-colors" data-id="element-199" data-mp="347853wl2wjvw">
                {m.num}
              </div>
              <div data-id="element-200" data-mp="jhshfah5pbah">
                <h3 className="text-sm sm:text-base font-bold text-brand-ink leading-tight" data-id="element-201" data-mp="jg7qduu1wahd">
                  ✅ {m.title}
                </h3>
                <p className="text-brand-blue text-xs sm:text-sm font-bold mt-0.5 leading-snug" data-id="element-202" data-mp="m1ff4yphg1su">
                  {m.tagline}
                </p>
                <p className="text-brand-slate text-xs sm:text-sm font-medium mt-1 leading-snug" data-id="element-203" data-mp="i159jn5lrdei">
                  {m.description}
                </p>
                <p className="text-brand-navy text-xs sm:text-sm font-semibold mt-1 leading-snug" data-id="element-204" data-mp="r0iafrfnutnm">
                  {m.closing}
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}